import script from "./RecAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./RecAccordion.vue?vue&type=style&index=0&id=e6d638ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6d638ae"]])

export default __exports__